import React from "react";
import PrivacyPolicyContent from "../components/Settings/PrivacyPolicyContent";

const PrivacyPolicy = () => {
  return (
    <>
      <PrivacyPolicyContent />
    </>
  );
};

export default PrivacyPolicy;
